/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CloudProviderRegion } from './cloudProviderRegion';
import { CloudProvidersEnum } from './cloudProvidersEnum';
import { DataCenter } from './dataCenter';


export interface CloudProvider { 
    provider: CloudProvidersEnum;
    enable_multiple_sddc_providers?: boolean;
    regions: Array<CloudProviderRegion>;
    datacenters?: Array<DataCenter>;
}
export namespace CloudProvider {
}


